"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports.createThemeOption = exports.consts = void 0;
var _styles = require("@mui/material/styles");
const defaultFontsize = 14;
const consts = exports.consts = {
  defaultFontsize: defaultFontsize,
  bigFontsize: defaultFontsize * 1.15
};
const createThemeOption = fontSize => ({
  typography: {
    fontFamily: ['メイリオ', "'ＭＳ Ｐゴシック'", "'MS PGothic'", "'ヒラギノ角ゴ Pro W3'", "'Hiragino Kaku Gothic Pro'", 'Meiryo', 'Osaka', 'sans-serif'].join(','),
    fontSize: fontSize,
    button: {
      fontWeight: 'bold'
    },
    content: {
      padding: '8px 8px'
    }
  },
  palette: {
    primary: {
      main: '#FFFFFF',
      contrastText: '#000000'
    },
    secondary: {
      main: '#17506E',
      contrastText: '#FFFFFF'
    },
    background: {
      paper: '#fff',
      default: '#efefef'
    },
    accent: {
      main: '#169FC2',
      contrastText: '#FFFFFF'
    },
    appBar: {
      main: '#FFFFFF',
      contrastText: '#000000'
    },
    cardHeader: {
      main: '#17506E',
      contrastText: '#FFFFFF'
    },
    required: {
      main: '#CC0000',
      contrastText: '#FFFFFF'
    },
    newInfo: {
      main: '#EF6D4B',
      contrastText: '#FFFFFF'
    },
    table: {
      header: {
        primary: {
          main: '#17506E',
          contrastText: '#FFFFFF',
          borderColor: '#0B344A'
        },
        secondary: {
          main: '#e7f2f8',
          contrastText: '#000000',
          borderColor: '#4b7c9c'
        }
      },
      body: {
        primary: {
          main: '#FFFFFF',
          contrastText: '#000000'
        },
        secondary: {
          main: '#E7F2F8',
          contrastText: '#000000'
        },
        tertiary: {
          main: '#c0d5ed',
          contrastText: '#000000'
        }
      },
      footer: {
        main: '#c0d5ed',
        contrastText: '#000000'
      },
      accent: {
        main: '#FFFF80',
        contrastText: '#000000'
      }
    },
    list: {
      primary: {
        main: '#FFFFFF',
        contrastText: '#000000'
      },
      secondary: {
        main: '#E7F2F8',
        contrastText: '#000000'
      }
    },
    risklevel: {
      high: {
        main: '#FF4B00',
        contrastText: '#000000'
      },
      middle: {
        main: '#FFF100',
        contrastText: '#000000'
      },
      low: {
        main: '#4DC4FF',
        contrastText: '#000000'
      },
      research: {
        main: '#FFCCFF',
        contrastText: '#000000'
      },
      none: {
        main: '#FFFFFF',
        contrastText: '#000000'
      }
    },
    text: {
      primary: '#333333',
      secondary: '#FFFFFF'
    },
    infomation: {
      primary: '#1360DD',
      secondary: '#f44336'
    },
    icon: {
      primary: '#FFFFFF',
      secondary: '#169FC2'
    },
    etcButton: {
      main: '#CBE1EE',
      secondary: '#000000'
    },
    graph: {
      red: '#FF4B00',
      blue: '#4DC4FF',
      yellow: '#FFF100',
      gray: '#EAEAEA',
      green: '#04AF7A'
    },
    select: {
      noneSelected: '#949494',
      notMatch: '#E5E5E5'
    },
    border: {
      white: '#FFFFFF',
      gray: '#BFBFBF'
    },
    error: {
      main: '#f44336',
      dark: '#D32F2F'
    },
    action: {
      selected: '#E5E5E5'
    }
  },
  divider: {
    height: 2
  },
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: 40
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          lineHeight: 1.4
        }
      }
    },
    MuiTypography: {
      defaultProps: {
        variant: 'body2'
      },
      styleOverrides: {
        root: {
          color: '#333333',
          lineHeight: 1.4,
          wordBreak: 'break-all'
        },
        h6: {
          color: '#333333',
          fontWeight: 700
        },
        subtitle1: {
          color: '#333333',
          fontSize: fontSize * 1.086,
          lineHeight: 1.4
        },
        body2: {
          color: '#333333',
          lineHeight: 1.4
        },
        h5: {
          color: '#333333',
          lineHeight: 1.4
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 'normal'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 'normal',
          fontSize: fontSize * 0.93
        },
        root: {
          padding: '4px 24px 4px 16px',
          borderBottom: 'none',
          lineHeight: 1.4
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&.Mui-disabled:before': {
            borderBottomStyle: 'solid'
          },
          '&.Mui-error:after': {
            borderBottom: '2px solid #f44336'
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: fontSize,
          lineHeight: 1.4,
          '&.Mui-error': {
            backgroundColor: '#fddad7'
          }
        },
        input: {
          padding: '0.7em'
        },
        inputMultiline: {
          padding: '0.3em'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.23)'
          },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            border: 'solid 2px #f44336'
          }
        },
        input: {
          padding: '0.7em'
        },
        inputMultiline: {
          padding: '0.3em'
        }
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: '8px 16px',
          height: 36
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '8px 8px'
        }
      }
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: '8px 8px',
          justifyContent: 'flex-end'
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '8px 16px',
          height: 36
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '16px 16px'
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '8px 8px',
          margin: 0
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: '8px 24px',
          height: 36
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: '8px 8px'
        }
      }
    },
    MuiAccordionActions: {
      styleOverrides: {
        root: {
          padding: '8px 8px'
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        regular: {
          minHeight: 42,
          '@media (min-width: 600px)': {
            minHeight: 50
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '0.5em 1em',
          textTransform: 'none'
        }
      },
      variants: [{
        props: {
          variant: 'contained',
          color: 'secondary'
        },
        style: {
          color: '#000000',
          backgroundColor: '#E5E5E5',
          '&:hover': {
            backgroundColor: '#E5E5E5'
          }
        }
      }, {
        props: {
          variant: 'contained',
          color: 'primary'
        },
        style: {
          color: '#FFFFFF',
          backgroundColor: '#199EEA',
          '&:hover': {
            backgroundColor: '#199EEA'
          }
        }
      }, {
        props: {
          variant: 'outlined',
          color: 'secondary'
        },
        style: {
          color: '#000000',
          backgroundColor: '#E5E5E5',
          '&:hover': {
            backgroundColor: '#E5E5E5'
          }
        }
      }, {
        props: {
          variant: 'outlined',
          color: 'primary'
        },
        style: {
          color: '#FFFFFF',
          backgroundColor: '#169FC2',
          '&:hover': {
            backgroundColor: '#36bFe2'
          }
        }
      }]
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: '8px'
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingBottom: 0
        },
        colorSecondary: {
          color: 'rgba(0, 0, 0, 0.54)'
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          height: 2
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            fontSize: fontSize,
            fontWeight: 'bold'
          }
        },
        contained: {
          marginLeft: 0
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#E5E5E5'
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#E5E5E5'
          }
        }
      }
    }
  },
  spacing: 8
});
exports.createThemeOption = createThemeOption;
const theme = exports.theme = (0, _styles.createTheme)(createThemeOption(defaultFontsize));